<script setup lang="ts">
import PrimeDialog from 'primevue/dialog'

interface Props {
  modelValue: boolean
  header?: string
  /** Panel width (any CSS length). Default `'400px'`. */
  width?: string
  /** Tap on mask dismisses the dialog. Default `true`. */
  dismissable?: boolean
  /** Show the X close icon in the header. Default `true`. */
  showCloseIcon?: boolean
  /** Modal (with mask + focus trap). Default `true`. */
  modal?: boolean
}

const props = withDefaults(defineProps<Props>(), {
  width: '400px',
  dismissable: true,
  showCloseIcon: true,
  modal: true,
})

const emit = defineEmits<{
  (e: 'update:modelValue', value: boolean): void
  (e: 'hide'): void
}>()

const pt = {
  root: {
    class: 'app-dialog__panel',
    style: { width: props.width, maxWidth: 'calc(100vw - 2rem)' },
  },
  header: { class: 'app-dialog__header' },
  content: { class: 'app-dialog__content' },
  mask: { class: 'app-dialog__mask' },
}

const onHide = () => {
  emit('update:modelValue', false)
  emit('hide')
}
</script>

<template>
  <PrimeDialog
    :visible="modelValue"
    :header="header"
    :dismissable-mask="dismissable"
    :closable="showCloseIcon"
    :modal="modal"
    :pt="pt"
    :block-scroll="true"
    @update:visible="(v: boolean) => !v && onHide()"
  >
    <template v-if="$slots.header" #header>
      <slot name="header" />
    </template>
    <slot />
  </PrimeDialog>
</template>
